import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import '../css/about.css';

const Privacy = () => {
  useEffect(() => {
    // Force header to be blue when component mounts
    const header = document.querySelector('.modern-header');
    if (header) {
      header.classList.remove('header-transparent');
      header.classList.add('header-scrolled');
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy - Petro Choice Integrated Services</title>
        <meta name="description" content="Privacy Policy for Petro Choice Integrated Services. Learn how we collect, use, and protect your personal information." />
        <meta name="keywords" content="privacy policy, data protection, personal information, Petro Choice" />
      </Helmet>

      {/* Hero Section */}
      <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '400px', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',top: '-122px' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="text-white mb-4" style={{ fontSize: '3rem', fontWeight: 'bold' }}>
                Privacy Policy
              </h1>
              <p className="text-white-50 mb-0" style={{ fontSize: '1.2rem' }}>
                How we protect and handle your personal information
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container my-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow-sm border-0">
              <div className="card-body p-5">
                <div className="mb-4">
                  <h2 className="text-primary mb-3">1. Information We Collect</h2>
                  <p className="text-muted">
                    We collect information you provide directly to us, such as when you create an account, 
                    contact us, or submit a job application. This may include:
                  </p>
                  <ul className="text-muted">
                    <li>Name, email address, and phone number</li>
                    <li>Professional information and work history</li>
                    <li>Resume and cover letter</li>
                    <li>Any other information you choose to provide</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">2. How We Use Your Information</h2>
                  <p className="text-muted">
                    We use the information we collect to:
                  </p>
                  <ul className="text-muted">
                    <li>Provide and maintain our services</li>
                    <li>Process job applications and employment inquiries</li>
                    <li>Communicate with you about our services</li>
                    <li>Send you updates and marketing materials (with your consent)</li>
                    <li>Improve our website and services</li>
                    <li>Comply with legal obligations</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">3. Information Sharing</h2>
                  <p className="text-muted">
                    We do not sell, trade, or otherwise transfer your personal information to third parties 
                    without your consent, except in the following circumstances:
                  </p>
                  <ul className="text-muted">
                    <li>With your explicit consent</li>
                    <li>To comply with legal requirements</li>
                    <li>To protect our rights and safety</li>
                    <li>In connection with a business transfer or merger</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">4. Data Security</h2>
                  <p className="text-muted">
                    We implement appropriate security measures to protect your personal information against 
                    unauthorized access, alteration, disclosure, or destruction. These measures include:
                  </p>
                  <ul className="text-muted">
                    <li>Encryption of sensitive data</li>
                    <li>Regular security assessments</li>
                    <li>Access controls and authentication</li>
                    <li>Secure data storage practices</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">5. Your Rights</h2>
                  <p className="text-muted">
                    You have the right to:
                  </p>
                  <ul className="text-muted">
                    <li>Access your personal information</li>
                    <li>Correct inaccurate information</li>
                    <li>Request deletion of your information</li>
                    <li>Withdraw consent for marketing communications</li>
                    <li>Lodge a complaint with supervisory authorities</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">6. Cookies and Tracking</h2>
                  <p className="text-muted">
                    We use cookies and similar technologies to enhance your browsing experience, 
                    analyze website traffic, and understand where our visitors are coming from. 
                    You can control cookie settings through your browser preferences.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">7. Third-Party Links</h2>
                  <p className="text-muted">
                    Our website may contain links to third-party websites. We are not responsible 
                    for the privacy practices of these external sites. We encourage you to review 
                    their privacy policies before providing any personal information.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">8. Children's Privacy</h2>
                  <p className="text-muted">
                    Our services are not intended for children under 13 years of age. We do not 
                    knowingly collect personal information from children under 13. If you believe 
                    we have collected such information, please contact us immediately.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">9. International Transfers</h2>
                  <p className="text-muted">
                    Your information may be transferred to and processed in countries other than 
                    your own. We ensure that such transfers comply with applicable data protection 
                    laws and implement appropriate safeguards.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">10. Changes to This Policy</h2>
                  <p className="text-muted">
                    We may update this Privacy Policy from time to time. We will notify you of 
                    any material changes by posting the new policy on this page and updating 
                    the "Last Updated" date.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">11. Contact Us</h2>
                  <p className="text-muted">
                    If you have any questions about this Privacy Policy or our data practices, 
                    please contact us at:
                  </p>
                  <div className="bg-light p-3 rounded">
                    <p className="mb-1"><strong>Email:</strong> privacy@petrochoice.org</p>
                    <p className="mb-0"><strong>Address:</strong> Almaadadi–Takseem Allasilki–Hussein hamouda street 12A/2, Cairo, Egypt</p>
                  </div>
                </div>

                <div className="text-center mt-5">
                  <p className="text-muted">
                    <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
